import React from 'react';

import * as css from './dateFilter.module.css';

const defaultDateSelections = [ '1d', '1w', '1m', '3m', '6m', '1y', 'YTD', '18m' ];

type DateFilterProps = {
    timeFrameinDays: string;
    selectTimeRange: (value: string) => unknown;
    disabled?: boolean;
    dateSelections?: string[];
};

export const DateFilter = ({
    timeFrameinDays,
    selectTimeRange,
    disabled = false,
    dateSelections = defaultDateSelections
}: DateFilterProps) => {
    return (
        <ul className={css.timeContainer}>
            {dateSelections.map((timeFrame: string) => (
                <li
                    className={`${css.timeOption} ${disabled ? css.disabledOption : ''}`}
                    data-select={timeFrameinDays.toLowerCase() === timeFrame.toLowerCase() ? 'Selected' : ''}
                    key={timeFrame}
                    onClick={() => !disabled && selectTimeRange(timeFrame)}
                >
                    {timeFrame.toUpperCase()}
                </li>
            ))}
        </ul>
    );
};